<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('series.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('series.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'classified-series' }">{{ $t('series.list.classified.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'live-streaming-series' }" v-if="$i18n.locale === 'tw'">{{ $t('series.livestream-list.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'ongoing-series' }" active>{{ $t('series.list.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <b-nav pills fill>
          <b-nav-item-dropdown :text="$t('series.list.recently-updated.title')" active>
            <b-dropdown-item :to="{ name: 'ongoing-series' }">{{ $t('series.list.recently-updated.ongoing.title') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'recently-added-series' }">{{ $t('series.list.recently-updated.recently-added.title') }}</b-dropdown-item>
            <!-- <b-dropdown-item :to="{ name: 'updated-series' }">{{ $t('series.list.recently-updated.updated.title') }}</b-dropdown-item> -->
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'classified-series' }" active>{{ $t('series.list.classified.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'series-search' }">{{ $t('series.list.search.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6 col-12">
        <b-button variant="outline-default" size="lg" v-b-modal.categories>{{ $t('series.list.classified.category-selector.hint') }}</b-button>
        <b-modal id="categories" :title="$t('series.list.classified.category-selector.hint')" size="lg" centered>
          <b-list-group>
            <b-list-group-item
              v-for="category in categories"
              :to="{ name: 'classified-series', query: { category_no: category.cag_no } }"
              :active="selected_category.cag_no === category.cag_no"
            >{{ $i18n.locale === 'tw' ? category.cag_name : category.cag_name_en }}[{{ category.cag_no }}]</b-list-group-item>
          </b-list-group>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h4
          v-if="Object.keys(selected_category).length > 0"
        >{{ $t('series.list.classified.label.selected-category') }}：{{ $i18n.locale === 'tw' ? selected_category.cag_name : selected_category.cag_name_en }}[{{ selected_category.cag_no }}]
        </h4>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <series-card-list :series="series"></series-card-list>
      <div class="row mt-3">
        <div class="col">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import SeriesCardList from '@/components/lists/SeriesCardList'

import i18n from '@/plugins/i18n.js'

import SeriesApiService from '@/services/budaedu-api-services/series-api-service.js'
import SeriesCategoryApiService from '@/services/budaedu-api-services/series-category-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(LinkPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(SeriesApiService)
Vue.use(SeriesCategoryApiService)

export default {
  i18n,
  name: 'classified-series',
  props: {
    category_no: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      is_loading: false,
      per_page: 30,
      page: 1,
      total: 0,
      series: [],
      categories: [],
      selected_category: null
    }
  },
  methods: {
    pageChange(page) {
      this.page = page
      this.setSeries()
    },
    async setCategories() {
      let param = { order: 'cag_no,asc'}
      if (this.$i18n.locale === 'en') {
        param.filter = { cag_no: 'C016,C025,C036' }
      }
      
      const items = await this.$seriesCategoryApiService.query(stringify(param).substr(1))
      this.categories = items.data
    },
    async setSeries() {
      this.is_loading = true
      this.series = []
      try {
        let items = {}
        const additional = stringify({
            filter: { IsDirtyEntry: 'N' },
            order: 'cdate,desc',
            per_page: this.per_page,
            page: this.page
        }).substr(1)
        
        if (this.category_no != '') {
          items = await this.$seriesApiService.queryByCategoryNo(this.category_no, additional)
        } else {
          items = await this.$seriesApiService.query(additional)
        }

        this.series = items.data
        this.total = items.meta.total
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`)
    await this.setCategories()

    if (this.category_no === '') {
      this.category_no = this.categories[0].cag_no
    }
    this.selected_category = this.categories.find(item => item.cag_no == this.category_no)

    await this.setSeries()
  },
  components: {
    SeriesCardList
  },
  metaInfo() {
    return {
      title: `${this.$t('series.list.classified.title')}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>